import { Box, styled } from '@material-ui/core';
import { SButton, SText } from '@setvi/shared/components';
import { useState } from 'react';

const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  borderRadius: 12,
  padding: '12px 16px',
  backgroundColor: '#EBF5FF'
});

const StyledButton = styled(SButton)(({ theme }) => ({
  padding: theme.spacing(0, 1),
  fontSize: 16,
  minHeight: 'min-content',
  marginLeft: theme.spacing(1),
  height: 'fit-content'
}));

interface InfoContainerProps {
  prefix?: string;
  text: string;
}

export const InfoContainer = ({ prefix, text }: InfoContainerProps) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);

  const button = (
    <StyledButton variant="text" onClick={() => setExpanded(prev => !prev)}>
      Read {expanded ? 'less' : 'more'}
    </StyledButton>
  );

  return (
    <Container>
      <SText
        lineHeight="24px"
        noLineClamp={expanded}
        prefix={!!prefix && <b style={{ marginRight: 4 }}>{prefix}</b>}
        disableTooltip
        getIsOverflow={val => setIsOverflow(val)}
        sufix={expanded && button}
        title={text}
      />
      {isOverflow && !expanded && button}
    </Container>
  );
};
